import { render } from "./TheContact.vue?vue&type=template&id=ac28c290&scoped=true"
import script from "./TheContact.vue?vue&type=script&lang=js"
export * from "./TheContact.vue?vue&type=script&lang=js"

import "./TheContact.vue?vue&type=style&index=0&id=ac28c290&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac28c290"]])

export default __exports__